import React from "react"
import PropTypes from "prop-types"
import moment from "moment"
import Grid from "./Grid"
import { getPath } from "../../pages/ClaimAnalysisPage/ClaimViewPage/PatientDetails"
import Period from "./Period"
import SelectionCheckbox from "./SelectionCheckbox.jsx"
import { gridStyles } from "../../pages/ClaimAnalysisPage/ClaimViewPage/PatientDetails/PatientDetails.tsx";
import EncounterDetail from "./Encounterdetail"

function getEncounterClass(encounter) {
    return encounter.class && typeof encounter.class == "object" ?
        getPath(encounter, "class.type.0.text") :
        encounter.class;
}

function getEncounterLabel(encounter) {
    let result = getPath(encounter, "type.0.text");
    if (result) {
        return result;
    }
    let _class = getEncounterClass(encounter);
    if (_class) {
        return _class + " encounter";
    }
    return "";
}

export default class Encounter extends React.Component {
    static propTypes = {
        resources: PropTypes.array,
        onSelectionChange: PropTypes.func,
        patientId: PropTypes.string,
        onGlobalSelectionChange: PropTypes.func,
        selectedResources: PropTypes.object,

    };

    constructor(props) {
        super(props);
        this.state = {
            selectedEncounter: null,
            isDetailOpen: false,
        };
    }

    handleRowClick = (encounter) => {
        this.setState({ selectedEncounter: encounter, isDetailOpen: true });
    };

    handleBack = () => {
        this.setState({ selectedEncounter: null, isDetailOpen: false });
    };

    render() {
        const RowCount = this.props.resources.length || 0
        return (
            <>

                {
                    this.state.isDetailOpen && this.state.selectedEncounter ? (
                        <EncounterDetail
                            encounter={this.state.selectedEncounter}
                            onBack={this.handleBack} 
                            patientId={this.props.patientId}
                            onSelectionChange={this.props.onGlobalSelectionChange}
                            selectedResources={this.props.selectedResources}
                        />
                    ) : (
                        <div style={gridStyles.wrapper}>
                            <div style={gridStyles.body}>
                                <div style={gridStyles.content}>
                                    <Grid
                                        rows={(this.props.resources || []).map(o => o.resource)}
                                        title={`${RowCount} Encounter${this.props.resources.length === 1 ? "" : "s"}`}
                                        groupBy="Type"
                                        comparator={(a, b) => {
                                            let dA = getPath(a, "period.start");
                                            let dB = getPath(b, "period.start");
                                            dA = dA ? +moment(dA) : 0;
                                            dB = dB ? +moment(dB) : 0;
                                            return dB - dA;
                                        }}
                                        onRowClick={this.handleRowClick}
                                        cols={[
                                            {
                                                label: <div className="text-center">Select</div>,
                                                render: o => (
                                                    <div className="text-center" onClick={e => e.stopPropagation()}>
                                                        <SelectionCheckbox
                                                            row={o}
                                                            checked={o.isSelected}
                                                            onSelectionChange={this.props.onSelectionChange}
                                                        />
                                                    </div>
                                                )
                                            },
                                            {
                                                label: "Type",
                                                path: rec => getEncounterLabel(rec),
                                                render: rec => {
                                                    let result = getPath(rec, "type.0.text");
                                                    if (result) {
                                                        return <b>{result}</b>;
                                                    }
                                                    let _class = getEncounterClass(rec);
                                                    if (_class) {
                                                        return (
                                                            <span className="text-muted">{_class + " encounter"}</span>
                                                        );
                                                    }
                                                    return <small className="text-muted">N/A</small>;
                                                }
                                            },
                                            {
                                                label: "Reason",
                                                path: "reason.0.coding.0.display",
                                                defaultValue: "N/A"
                                            },
                                            {
                                                label: "Class",
                                                render: rec => {
                                                    let result = getEncounterClass(rec);
                                                    return result ?
                                                        <b>{result}</b> :
                                                        <small className="text-muted">N/A</small>;
                                                }
                                            },
                                            {
                                                label: "Status",
                                                path: "status",
                                                defaultValue: "N/A"
                                            },
                                            {
                                                label: "Time",
                                                path: "period",
                                                render: o => Period(o.period || {})
                                            }
                                        ]}
                                    />
                                </div>
                            </div>
                        </div>
                    )}
            </>
        );
    }
}

